import React, { useEffect, useRef } from "react";

// const Tiframe =({tDData}) => {
    
//     let form=useRef();
//     // useEffect(()=>{
//     //   form.current.submit();
//   // }, []);
//   useEffect(() => {
//     if (tDData?.ACSUrl && tDData?.jwt) {
//       form.current.submit();
//     }
//   }, [tDData]);
//   return (     
//     <iframe
//     name="threeDSFrame"
//     style={{ width: "100%", height: "500px", border: "none" }}
//   >
//         <form  ref={form} id="form1" action={tDData?.ACSUrl}  method="post">
//         <input name="JWT" hidden value={tDData?.jwt}/>
//         <input name="MD" hidden value={tDData?.MD} />
//         <input name="TermUrl" hidden value={tDData?.TermUrl} />
//         <div style={{display:'flex',  right: '40%', marginTop:'40%', textAlign: 'center', justifyContent:'center'}}>
//         <button type='submit'>Continue</button>
//         </div>
//       </form>
//       </iframe>
//     )
// }



const Tiframe = ({ tDData }) => {
  const form = useRef();

  useEffect(() => {
    if (tDData?.ACSUrl && tDData?.jwt) {
      form.current.submit();
    }
  }, [tDData]);

  return (
    <>
      {/* iframe FIRST */}
      <iframe
        name="threeDSFrame"
        style={{ width: "100%", height: "500px", border: "none" }}
      />

      {/* form OUTSIDE iframe */}
      <form
        ref={form}
        action={tDData?.ACSUrl}
        method="POST"
        target="threeDSFrame"   // ✅ THIS is the key line
      >
        <input name="JWT" value={tDData?.jwt} hidden />
        <input name="MD" value={tDData?.MD} hidden />
        <input name="TermUrl" value={tDData?.TermUrl} hidden />
      </form>
    </>
  );
};

 export default Tiframe;